import {SHUTTERFLY_DATA} from '~/create/constants/shutterfly';
import {LEGO_DATA} from '~/create/constants/lego';

export function composeEventHandlers(internal, external) {
  return external
    ? (e) => {
        internal(e);
        external(e);
      }
    : internal;
}

/**
 * Check if a modal is currently opened in the page
 * @returns {boolean} true if modal is opened. false otherwise
 *
 */
export function isModalOpen() {
  try {
    return window.EviteModal.currentInstance.open;
  } catch (e) {
    return false;
  }
}

export function getSponsorAd(event, availableSponsors, skipPremiumVerification = false) {
  if (!skipPremiumVerification) {
    if (event.origin === 13) return false;
  }
  if (!availableSponsors || !availableSponsors.length) {
    return false;
  }

  const eventType = event.event_type;
  const matchSponsor = availableSponsors.filter((sponsor) => {
    const isFeatureEnabled = !sponsor.featureName || evite.features.isEnabled(sponsor.featureName);
    return sponsor.categories.includes(eventType) && isFeatureEnabled;
  });
  if (matchSponsor) return matchSponsor[0];
  return false;
}

export function showLegoAd(event) {
  const eventType = event.event_type;
  const featureName = LEGO_DATA.feature_name;
  const lego = evite.features.isEnabled(featureName);
  if (lego && !window.is_premium) {
    const validEventTypes = LEGO_DATA.supported_event_types;
    const isLegoEventType = validEventTypes.includes(eventType);
    return isLegoEventType;
  }

  return false;
}

export function shouldShowSponsoredRegistry(event) {
  const eventType = event.event_type;
  return Boolean(
    window.sponsored_registry_form_data && window.sponsored_registry_form_data[eventType]
  );
}

/**
 * get the wording position on premium uyo templates
 * @param userText
 */
export function getWordingPosition(userText) {
  const textEditorStyles = {
    left: userText.x,
    top: userText.y,
    position: 'absolute',
    width: userText.x2 - userText.x,
    height: userText.y2 - userText.y + 10,
  };
  return textEditorStyles;
}
